const Header = {
    $header: null,
    $burger: null,
    $menu: null,

    toggleMenu() {
        const isActive = this.$menu.classList.toggle("is-active");
        this.$burger.classList.toggle("is-active");
        this.$header.classList.toggle("menu-is-open");
        document.body.style.overflow = isActive ? "hidden" : "";
    },

    closeMenu() {
        if (this.$menu.classList.contains("is-active")) {
            this.$menu.classList.remove("is-active");
            this.$header.classList.remove("menu-is-open");
            this.$burger.classList.remove("is-active");
            document.body.style.overflow = "";
        }
    },

    handleDocumentClick(event) {
        if (
            this.$menu.classList.contains("is-active") &&
            !this.$menu.contains(event.target) &&
            !this.$burger.contains(event.target)
        ) {
            this.closeMenu();
        }
    },

    bindEvents() {
        if (this.$burger) {
            Emits.on(this.$burger, "click", () => this.toggleMenu());
        }
        document.addEventListener("click", (event) =>
            this.handleDocumentClick(event)
        );
    },

    init() {
        this.$header = DOM.select('[data-selector="header"]');
        if (!this.$header) return;

        this.$burger = DOM.find(
            this.$header,
            '[data-selector="header.burger"]'
        );
        this.$menu = DOM.find(this.$header, '[data-selector="header.menu"]');
        if (this.$burger && this.$menu) {
            this.bindEvents();
        }
    },
};

export default Header;
